import { http } from '@/core/api/';
const apiUrl = 'api/pei/strengthneed';

export const initFilters = () => {
  return http.get(`${apiUrl}/initfilters`);
};

export const search = (params) => {
  return http.get(`${apiUrl}/search`, {
    params,
  });
};

export const add = (payload) => {
  return http.post(`${apiUrl}/add`, payload)
}

export const inactive = (payload) => {
  return http.put(`${apiUrl}/inactive`, payload)
}
